/** @jsx jsx */
import { useStaticQuery, graphql } from "gatsby"
import { jsx, Box } from "theme-ui"
import Img from "gatsby-image"

const PolisSection = () => {
  const data = useStaticQuery(graphql`
    query polisMIT {
      file(relativePath: { eq: "mit_polis.png" }) {
        childImageSharp {
          # Specify the image processing specifications right in the query.
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Box>
      <Img
        sx={{ my: 5, maxWidth: "40em" }}
        fluid={data.file.childImageSharp.fluid}
      />
    </Box>
  )
}

export default PolisSection
